import { AppSelect } from '../ui/AppSelect';
import React from 'react';
import { IMAGE_AI_PROVIDERS } from '../../constants/globalAiProviders';
import { setStoredImageProvider } from '../../utils/wanxImageCapabilities';
import { DATASTART_IMAGE_CAPABILITY_HINT, isDatastartImageProvider } from '../../constants/datastartImageModels';

const ImageProviderSelect = ({ value, onChange, className = '' }) => (
  <AppSelect
    value={value}
    onChange={(event) => onChange?.(setStoredImageProvider(event.target.value))}
    className={`max-w-[260px] rounded-lg px-2.5 py-1.5 text-xs font-bold outline-none ${className}`}
    title={isDatastartImageProvider(value) ? DATASTART_IMAGE_CAPABILITY_HINT : '图片生成模型'}
    aria-label="图片生成模型"
    style={{
      backgroundColor: 'var(--color-bg-secondary)',
      color: 'var(--color-text-secondary)',
      border: '1px solid var(--color-border-primary)',
    }}
  >
    {IMAGE_AI_PROVIDERS.map((provider) => (
      <option key={provider.id} value={provider.id}>{provider.name}</option>
    ))}
  </AppSelect>
);

export default React.memo(ImageProviderSelect);
